import Raven from 'raven-js';
export const containsDuplicateChars = str => {
  return /(.)(?:.*\1){1,}/.test(str);
};
const strToRegExp = str => {
  const matches = str.match(/^([/])(.*?)\1([gimsuy]*)$/);
  try {
    if (matches === null || containsDuplicateChars(matches[3])) {
      return new RegExp(str);
    }
    return new RegExp(matches[2], matches[3]);
  } catch (err) {
    Raven.captureException(err);
    return undefined;
  }
};
export const isValidRegExpStr = str => {
  try {
    const m = str.match(/^([/~@;%#'])(.*?)\1([gimsuy]*)$/);
    return m ? !!new RegExp(m[2], m[3]) : false;
  } catch (e) {
    return false;
  }
};
export default strToRegExp;